import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

const API_BASE = '/api/v1';

/**
 * Abre uma conexão SSE com o backend e invalida a consulta do projeto
 * sempre que o cronograma for recomputado.
 */
export function useScheduleSse(projetoId: string, queryKey: readonly unknown[]) {
  const qc = useQueryClient();

  useEffect(() => {
    const source = new EventSource(`${API_BASE}/projects/${projetoId}/schedule/events`);

    source.onmessage = () => {
      void qc.invalidateQueries({ queryKey: queryKey as string[] });
    };

    return () => source.close();
  }, [projetoId, qc, queryKey]);
}
